import axios from 'axios';
import React, { useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  selectCollectionAccountDetails,
  setAlertWithTitle,
  setCollectionAccountDetails,
  setListStationMasterModalStatus,
  setModPartyMasterHelpStatus,
  setSessionExpired,
} from '../../utility/Redux/modal';

import {
  selectDefultProfileSetting,
  selectPrefix,
  selectreportFromDate,
  selectreportToDate,
  selectStationId,
  selectStationName,
  selectUserType,
  setreportsFromDate,
  setreportsTodate,
  setStationID,
  setStationName,
} from '../../utility/Redux/profile';

import { FormatNumber2 } from '../../utility/component/tools';
import { PartyLedgerFooter } from '../../utility/component/datagrid/partyFooter';
import { selectToken } from '../../utility/Redux/security';
import ModListStationMaster from '../../utility/component/modals/modListStationMaster';
import { GeniusHeader } from '../../utility/component/datagrid/geniusHeader';
import { useRef } from 'react';
import ReactToPrint from 'react-to-print';

import TableGenius from '../../utility/component/geniusComponents/table';
import { FromToDate } from '../../utility/component/fromToDate';
import { PrintButton } from '../../utility/component/buttons';
import { setReportType } from '../../utility/Redux/refresh';
import GeniusSelectDate from '../../utility/component/selectDate';
import ModPartyMasterHelp from '../../master/partyMasterHelp';
import GeniusTableForReports from '../../utility/component/geniusComponents/geniusTableforReports';
import moment from 'moment';
import dataToLocal from '../../utility/functions/summaryToLocal';
import IsLocalData from '../../utility/functions/ceckLocalData';
import deleteWholeDatabase from '../../utility/functions/deleteWholeDatabase';
import { CallAPIPromise } from './dashboard/biiling/modal/comman';
import { GeniusPaginationButtons } from '../../utility/component/datagrid/geniusPagination';
import { BarChart3, Printer, Table2 } from 'lucide-react';
const width = window.innerWidth / 100;
const REPORT_PAGE_SIZE = 16;

const REPORT_COLUMNS = [
  { field: 'ACCOUNT_NO', label: 'Acc No.', width: 90, align: 'left' },
  { field: 'NAME', label: 'Party Name', width: 240, align: 'left' },
  { field: 'ADDRESS', label: 'Address', width: 220, align: 'left' },
  { field: 'MOBILE', label: 'Mobile', width: 120, align: 'left' },
  { field: 'OPENING_BALANCE', label: 'Opening Balance', width: 130, align: 'right' },
  { field: 'OPENING_DEBIT', label: 'Debit', width: 110, align: 'right' },
  { field: 'OPENING_CREDIT', label: 'Credit', width: 110, align: 'right' },
  { field: 'CLOSING_BALANCE', label: 'Closing Balance', width: 130, align: 'right' },
  {
    field: 'CLOSING_WITHOUT_OPENING',
    label: 'Closing Without Opening',
    width: 155,
    align: 'right',
  },
];

const readAmount = (value) => {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : 0;
  }

  if (!value) {
    return 0;
  }

  const amount = Number(String(value).replace(/,/g, '').replace(/[^\d.-]/g, ''));
  return Number.isFinite(amount) ? amount : 0;
};

const readBalanceType = (row, amountField, typeField) => {
  if (row[typeField]) {
    return row[typeField];
  }

  const value = String(row[amountField] || '').toUpperCase();
  if (value.includes('CR')) {
    return 'Cr';
  }
  if (value.includes('DR')) {
    return 'Dr';
  }

  return '';
};

const getReportTotals = (rows) =>
  rows.reduce(
    (totals, row) => {
      const opening = readAmount(row.OPENING_BALANCE);
      const openingType = readBalanceType(
        row,
        'OPENING_BALANCE',
        'OPENING_BAL_TYPE'
      );
      const closing = readAmount(row.CLOSING_BALANCE);
      const closingType = readBalanceType(
        row,
        'CLOSING_BALANCE',
        'CLOSING_BAL_TYPE'
      );
      const closingWithoutOpening = readAmount(row.CLOSING_WITHOUT_OPENING);
      const closingWithoutOpeningType = readBalanceType(
        row,
        'CLOSING_WITHOUT_OPENING',
        'CLOSING_WITHOUT_OPENING_TYPE'
      );

      totals.opening[openingType === 'Cr' ? 'cr' : 'dr'] += opening;
      totals.debit += readAmount(row.OPENING_DEBIT || row.DEBIT);
      totals.credit += readAmount(row.OPENING_CREDIT || row.CREDIT);
      totals.closing[closingType === 'Cr' ? 'cr' : 'dr'] += closing;
      totals.closingWithoutOpening[
        closingWithoutOpeningType === 'Cr' ? 'cr' : 'dr'
      ] += closingWithoutOpening;

      return totals;
    },
    {
      opening: { dr: 0, cr: 0 },
      debit: 0,
      credit: 0,
      closing: { dr: 0, cr: 0 },
      closingWithoutOpening: { dr: 0, cr: 0 },
    }
  );

const BalanceTotal = ({ value }) => (
  <div className="space-y-0.5 text-[11px] font-bold leading-4">
    {value.dr > 0 ? <div className="text-red-700">{FormatNumber2(value.dr)} Dr</div> : null}
    {value.cr > 0 ? (
      <div className="text-emerald-700">{FormatNumber2(value.cr)} Cr</div>
    ) : null}
    {!value.dr && !value.cr ? <span>-</span> : null}
  </div>
);

const PartyBalanceTable = ({ rows, allRows, loading }) => {
  const totals = React.useMemo(() => getReportTotals(allRows), [allRows]);
  const specialColumnClass = (field, section) => {
    if (field !== 'CLOSING_WITHOUT_OPENING') {
      return '';
    }

    if (section === 'header') {
      return 'bg-sky-100 text-sky-900';
    }

    return 'bg-sky-50/80';
  };

  return (
    <div className="overflow-hidden rounded-md border border-slate-300 bg-white shadow-sm">
      <div className="overflow-x-auto">
        <table className="w-full min-w-[1275px] table-fixed border-collapse text-xs">
          <colgroup>
            {REPORT_COLUMNS.map((column) => (
              <col key={column.field} style={{ width: column.width }} />
            ))}
          </colgroup>
          <thead className="bg-slate-100 text-slate-700">
            <tr>
              {REPORT_COLUMNS.map((column) => (
                <th
                  key={column.field}
                  className={`border-b border-r border-slate-300 px-2 py-2 font-bold last:border-r-0 ${specialColumnClass(
                    column.field,
                    'header'
                  )} text-center`}
                >
                  {column.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={REPORT_COLUMNS.length} className="h-48 text-center text-slate-500">
                  Loading report...
                </td>
              </tr>
            ) : rows.length ? (
              rows.map((row, index) => (
                <tr
                  key={row.id || `${row.ACCOUNT_NO}-${index}`}
                  className="odd:bg-white even:bg-slate-50/70 hover:bg-blue-50"
                >
                  {REPORT_COLUMNS.map((column) => (
                    <td
                      key={column.field}
                      title={row[column.field] || ''}
                      className={`h-9 truncate border-b border-r border-slate-200 px-2 last:border-r-0 ${specialColumnClass(
                        column.field,
                        'body'
                      )} ${
                        column.align === 'right'
                          ? 'text-right tabular-nums'
                          : 'text-left'
                      }`}
                    >
                      {row[column.field] || ''}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={REPORT_COLUMNS.length} className="h-48 text-center text-slate-500">
                  No records found
                </td>
              </tr>
            )}
          </tbody>
          <tfoot className="bg-slate-200 text-slate-900">
            <tr>
              <td className="border-r border-t border-slate-300 px-2 py-2" />
              <td className="border-r border-t border-slate-300 px-2 py-2 font-bold">
                Grand Total
                <div className="font-normal text-slate-500">{allRows.length} parties</div>
              </td>
              <td className="border-r border-t border-slate-300 px-2 py-2" />
              <td className="border-r border-t border-slate-300 px-2 py-2" />
              <td className="border-r border-t border-slate-300 px-2 py-2 text-right">
                <BalanceTotal value={totals.opening} />
              </td>
              <td className="border-r border-t border-slate-300 px-2 py-2 text-right font-bold tabular-nums">
                {FormatNumber2(totals.debit)}
              </td>
              <td className="border-r border-t border-slate-300 px-2 py-2 text-right font-bold tabular-nums">
                {FormatNumber2(totals.credit)}
              </td>
              <td className="border-r border-t border-slate-300 px-2 py-2 text-right">
                <BalanceTotal value={totals.closing} />
              </td>
              <td className="border-t border-sky-200 bg-sky-100 px-2 py-2 text-right">
                <BalanceTotal value={totals.closingWithoutOpening} />
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
};

const isOpeningRow = (row) =>
  String(row.ACCOUNT_NO || '').toUpperCase() === 'OPENING BALANCE';

const getTopParties = (rows, openingAllowed, limit = 10) => {
  const closingField = openingAllowed
    ? 'CLOSING_BALANCE'
    : 'CLOSING_WITHOUT_OPENING';
  const closingTypeField = openingAllowed
    ? 'CLOSING_BAL_TYPE'
    : 'CLOSING_WITHOUT_OPENING_TYPE';

  return rows
    .filter((row) => !isOpeningRow(row))
    .map((row) => {
      const value = readAmount(row[closingField]);
      return {
        label: `${row.ACCOUNT_NO || ''}${row.NAME ? ` - ${row.NAME}` : ''}`,
        value,
        type: readBalanceType(row, closingField, closingTypeField),
      };
    })
    .filter((row) => row.value > 0)
    .sort((a, b) => b.value - a.value)
    .slice(0, limit);
};

const MetricCard = ({ label, value, tone = 'default', subText }) => {
  const toneClass =
    tone === 'danger'
      ? 'border-red-200 bg-red-50 text-red-800'
      : tone === 'success'
      ? 'border-emerald-200 bg-emerald-50 text-emerald-800'
      : tone === 'info'
      ? 'border-blue-200 bg-blue-50 text-blue-800'
      : 'border-slate-200 bg-white text-slate-800';

  return (
    <div className={`rounded-md border px-3 py-2 ${toneClass}`}>
      <div className="text-[11px] font-semibold uppercase tracking-wide opacity-70">
        {label}
      </div>
      <div className="mt-1 text-lg font-bold">{value}</div>
      {subText ? <div className="text-[11px] opacity-70">{subText}</div> : null}
    </div>
  );
};

const BalanceBar = ({ label, value, maxValue, tone = 'default' }) => {
  const percent = maxValue > 0 ? Math.max((value / maxValue) * 100, 3) : 0;
  const barClass =
    tone === 'credit'
      ? 'bg-emerald-500'
      : tone === 'debit'
      ? 'bg-red-500'
      : 'bg-blue-500';

  return (
    <div className="space-y-1">
      <div className="flex items-center justify-between gap-3 text-xs">
        <span className="truncate font-semibold text-slate-700">{label}</span>
        <span className="shrink-0 font-semibold text-slate-900">
          {FormatNumber2(value)}
        </span>
      </div>
      <div className="h-2 rounded-full bg-slate-100">
        <div
          className={`h-2 rounded-full ${barClass}`}
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  );
};

const TopPartiesPanel = ({ rows, openingAllowed }) => {
  const parties = React.useMemo(
    () => getTopParties(rows, openingAllowed, 10),
    [rows, openingAllowed]
  );
  const maxValue = Math.max(...parties.map((party) => party.value), 1);

  return (
    <div className="w-full shrink-0 rounded-md border border-slate-200 bg-white p-3 shadow-sm print:hidden xl:w-72">
      <div className="flex items-center justify-between border-b border-slate-100 pb-2">
        <div>
          <div className="text-sm font-bold text-slate-800">Top 10 Parties</div>
          <div className="text-xs text-slate-500">Highest closing balance</div>
        </div>
        <div className="rounded-full bg-slate-100 px-2 py-1 text-[11px] font-bold text-slate-600">
          {parties.length}
        </div>
      </div>

      <div className="mt-3 max-h-[560px] space-y-3 overflow-y-auto pr-1">
        {parties.length ? (
          parties.map((party, index) => (
            <div key={`${party.label}-${index}`} className="space-y-1">
              <div className="flex items-center gap-2">
                <div className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-slate-100 text-[10px] font-bold text-slate-600">
                  {index + 1}
                </div>
                <div className="min-w-0 flex-1">
                  <BalanceBar
                    label={party.label}
                    value={party.value}
                    maxValue={maxValue}
                    tone={party.type === 'Cr' ? 'credit' : 'debit'}
                  />
                </div>
              </div>
              <div
                className={`pl-7 text-[11px] font-bold ${
                  party.type === 'Cr' ? 'text-emerald-700' : 'text-red-700'
                }`}
              >
                {party.type || 'Balance'}
              </div>
            </div>
          ))
        ) : (
          <div className="rounded-md bg-slate-50 p-3 text-xs text-slate-500">
            No balance found
          </div>
        )}
      </div>
    </div>
  );
};

const PartyBalanceGraph = ({ rows, openingAllowed }) => {
  const graphData = React.useMemo(() => {
    const summary = {
      openingDr: 0,
      openingCr: 0,
      debit: 0,
      credit: 0,
      closingDr: 0,
      closingCr: 0,
      topDr: [],
      topCr: [],
      stationRows: [],
    };

    const stations = {};

    rows.forEach((row) => {
      const openingAmount = readAmount(row.OPENING_BALANCE);
      const openingType = readBalanceType(row, 'OPENING_BALANCE', 'OPENING_BAL_TYPE');
      const debit = readAmount(row.DEBIT || row.OPENING_DEBIT);
      const credit = readAmount(row.CREDIT || row.OPENING_CREDIT);
      const closingField = openingAllowed
        ? 'CLOSING_BALANCE'
        : 'CLOSING_WITHOUT_OPENING';
      const closingTypeField = openingAllowed
        ? 'CLOSING_BAL_TYPE'
        : 'CLOSING_WITHOUT_OPENING_TYPE';
      const closingAmount = readAmount(row[closingField]);
      const closingType = readBalanceType(row, closingField, closingTypeField);
      const sid = row.SID || 'All';

      if (openingType === 'Dr') {
        summary.openingDr += openingAmount;
      } else if (openingType === 'Cr') {
        summary.openingCr += openingAmount;
      }

      summary.debit += debit;
      summary.credit += credit;

      if (closingType === 'Dr') {
        summary.closingDr += closingAmount;
      } else if (closingType === 'Cr') {
        summary.closingCr += closingAmount;
      }

      if (!stations[sid]) {
        stations[sid] = {
          sid,
          debit: 0,
          credit: 0,
          closingDr: 0,
          closingCr: 0,
        };
      }

      stations[sid].debit += debit;
      stations[sid].credit += credit;
      if (closingType === 'Dr') {
        stations[sid].closingDr += closingAmount;
      } else if (closingType === 'Cr') {
        stations[sid].closingCr += closingAmount;
      }

      if (!isOpeningRow(row) && closingAmount > 0) {
        const party = {
          label: `${row.ACCOUNT_NO || ''}${row.NAME ? ` - ${row.NAME}` : ''}`,
          value: closingAmount,
        };
        if (closingType === 'Dr') {
          summary.topDr.push(party);
        } else if (closingType === 'Cr') {
          summary.topCr.push(party);
        }
      }
    });

    summary.topDr = summary.topDr.sort((a, b) => b.value - a.value).slice(0, 50);
    summary.topCr = summary.topCr.sort((a, b) => b.value - a.value).slice(0, 50);
    summary.stationRows = Object.values(stations).sort((a, b) =>
      String(a.sid).localeCompare(String(b.sid))
    );

    return summary;
  }, [rows, openingAllowed]);

  if (!rows.length) {
    return null;
  }

  const maxClosing = Math.max(graphData.closingDr, graphData.closingCr, 1);
  const maxParty = Math.max(
    ...graphData.topDr.map((item) => item.value),
    ...graphData.topCr.map((item) => item.value),
    1
  );
  const netClosing = graphData.closingDr - graphData.closingCr;
  const netType = netClosing >= 0 ? 'Dr' : 'Cr';

  return (
    <div className="mt-2 rounded-md border border-slate-200 bg-slate-50 p-2 shadow-sm print:hidden">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div>
          <div className="text-sm font-bold text-slate-800">
            Party Balance Graph
          </div>
          <div className="text-xs text-slate-500">
            Clean view of closing balance, top pending parties and station totals
          </div>
        </div>
        <div className="rounded-full border border-slate-200 bg-white px-3 py-1 text-xs font-semibold text-slate-600">
          {rows.length} rows
        </div>
      </div>

      <div className="mt-2 grid grid-cols-2 gap-2 md:grid-cols-5">
        <MetricCard
          label="Closing Dr"
          value={`${FormatNumber2(graphData.closingDr)} Dr`}
          tone="danger"
        />
        <MetricCard
          label="Closing Cr"
          value={`${FormatNumber2(graphData.closingCr)} Cr`}
          tone="success"
        />
        <MetricCard
          label="Net Closing"
          value={`${FormatNumber2(Math.abs(netClosing))} ${netType}`}
          tone={netType === 'Dr' ? 'danger' : 'success'}
        />
        <MetricCard label="Debit" value={FormatNumber2(graphData.debit)} tone="info" />
        <MetricCard label="Credit" value={FormatNumber2(graphData.credit)} />
      </div>

      <div className="mt-2 grid gap-2 xl:grid-cols-3">
        <div className="rounded-md border border-slate-200 bg-white p-2">
          <div className="mb-2 text-xs font-bold uppercase text-slate-500">
            Dr / Cr Split
          </div>
          <div className="space-y-3">
            <BalanceBar
              label="Closing Dr"
              value={graphData.closingDr}
              maxValue={maxClosing}
              tone="debit"
            />
            <BalanceBar
              label="Closing Cr"
              value={graphData.closingCr}
              maxValue={maxClosing}
              tone="credit"
            />
          </div>
        </div>

        <div className="rounded-md border border-slate-200 bg-white p-2">
          <div className="mb-2 text-xs font-bold uppercase text-slate-500">
            Top Dr Parties
          </div>
          <div className="max-h-[500px] space-y-2 overflow-y-auto pr-1">
            {graphData.topDr.length ? (
              graphData.topDr.map((item) => (
                <BalanceBar
                  key={`dr-${item.label}`}
                  label={item.label}
                  value={item.value}
                  maxValue={maxParty}
                  tone="debit"
                />
              ))
            ) : (
              <div className="text-xs text-slate-500">No Dr balance found</div>
            )}
          </div>
        </div>

        <div className="rounded-md border border-slate-200 bg-white p-2">
          <div className="mb-2 text-xs font-bold uppercase text-slate-500">
            Top Cr Parties
          </div>
          <div className="max-h-[500px] space-y-2 overflow-y-auto pr-1">
            {graphData.topCr.length ? (
              graphData.topCr.map((item) => (
                <BalanceBar
                  key={`cr-${item.label}`}
                  label={item.label}
                  value={item.value}
                  maxValue={maxParty}
                  tone="credit"
                />
              ))
            ) : (
              <div className="text-xs text-slate-500">No Cr balance found</div>
            )}
          </div>
        </div>
      </div>

      {graphData.stationRows.length > 1 ? (
        <div className="mt-3 overflow-hidden rounded-md border border-slate-200 bg-white">
          <div className="border-b border-slate-200 px-3 py-2 text-xs font-bold uppercase text-slate-500">
            Station Summary
          </div>
          <div className="grid grid-cols-5 bg-slate-100 px-3 py-2 text-xs font-bold text-slate-600">
            <div>SID</div>
            <div className="text-right">Debit</div>
            <div className="text-right">Credit</div>
            <div className="text-right">Closing Dr</div>
            <div className="text-right">Closing Cr</div>
          </div>
          {graphData.stationRows.map((station) => (
            <div
              key={station.sid}
              className="grid grid-cols-5 border-t border-slate-100 px-3 py-2 text-xs text-slate-700"
            >
              <div className="font-semibold">{station.sid}</div>
              <div className="text-right">{FormatNumber2(station.debit)}</div>
              <div className="text-right">{FormatNumber2(station.credit)}</div>
              <div className="text-right font-semibold text-red-700">
                {FormatNumber2(station.closingDr)}
              </div>
              <div className="text-right font-semibold text-emerald-700">
                {FormatNumber2(station.closingCr)}
              </div>
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
};

const PartyWiseBalanceReport = () => {
  const dispatch = useDispatch();
  const printRef = useRef();
  const ReduxStation_id = useSelector(selectStationId);
  const accDetails = useSelector(selectCollectionAccountDetails);
  const { accNumber } = accDetails;
  const firstDate = useSelector(selectreportFromDate);
  const SecondDate = useSelector(selectreportToDate);
  const userType = useSelector(selectUserType);
  const defaultProfile = useSelector(selectDefultProfileSetting);
  const [list, setList] = useState([]);
  const [openingAllowed] = useState(true);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [activeView, setActiveView] = useState('report');

  const [fromDate, setFromDate] = useState(firstDate);
  const [fromDateFocus, setFromDateFocus] = useState(false);
  const [toDate, setToDate] = useState(SecondDate);
  const [toDateFocus, setToDateFocus] = useState(false);
  const ReduxStationName = useSelector(selectStationName);

  const columns = React.useMemo(
    () => [
   



      {
        field: 'ACCOUNT_NO',
        type: 'number',
        accessor: 'ACCOUNT_NO',
        // header:'Date',
        width: width * 5,
        cellClassName: 'super-app-theme--cell',
        headerAlign: 'center',
        align: 'left',
        headerClassName: 'super-app-theme--header',

        renderHeader: (params) => (
          <strong className="text-[#555a66]" style={{ fontSize: 13 }}>
            {'Acc No.'}
          </strong>
        ),
      },
      {
        field: 'NAME',
        type: 'number',
        accessor: 'NAME',
        // header:'Date',
        cellClassName: 'super-app-theme--cell',
        width: 250,
        headerAlign: 'center',
        align: 'left',
        headerClassName: 'super-app-theme--header',

        renderHeader: (params) => (
          <strong className="text-[#555a66]" style={{ fontSize: 13 }}>
            {'Party Name'}
          </strong>
        ),
      },
      {
        field: 'ADDRESS',
        type: 'number',
        accessor: 'ADDRESS',
        // header:'Date',
        cellClassName: 'super-app-theme--cell',
        width: 200,
        headerAlign: 'center',
        align: 'left',
        headerClassName: 'super-app-theme--header',

        renderHeader: (params) => (
          <strong className="text-[#555a66]" style={{ fontSize: 13 }}>
            {'Address'}
          </strong>
        ),
      },
      {
        field: 'MOBILE',
        type: 'number',
        accessor: 'MOBILE',
        // header:'Date',
        cellClassName: 'super-app-theme--cell',
        width: 100,
        headerAlign: 'center',
        align: 'left',
        headerClassName: 'super-app-theme--header',

        renderHeader: (params) => (
          <strong className="text-[#555a66]" style={{ fontSize: 13 }}>
            {'Mobile'}
          </strong>
        ),
      },

    

      {
        field: 'OPENING_BALANCE',
        type: 'string',
        align: 'right',
        width:100,
        headerAlign: 'center',
        accessor: 'OPENING_BALANCE',
        cellClassName: 'super-app-theme--cell',
        headerClassName: 'super-app-theme--header',
        renderHeader: (params) => (
          <strong className="text-[#555a66]" style={{ fontSize: 13 }}>
            {'Opening Bal.'}
          </strong>
        ),
      },

      {
        field: 'OPENING_DEBIT',
        type: 'string',
        accessor: 'OPENING_DEBIT',
        align: 'right',
        width:100,
        headerAlign: 'center',

        headerClassName: 'super-app-theme--header',
        cellClassName: 'super-app-theme--cell',
        renderHeader: (params) => (
          <strong className="text-[#555a66]" style={{ fontSize: 13 }}>
            {'Debit'}
          </strong>
        ),
      },
  
      {
        field: 'OPENING_CREDIT',
        type: 'string',
        accessor: 'OPENING_CREDIT',

        align: 'right',
        width:100,
        headerAlign: 'center',
        cellClassName: 'super-app-theme--cell',
      

        headerClassName: 'super-app-theme--header',
        renderHeader: (params) => (
          <strong className="text-[#555a66]" style={{ fontSize: 13 }}>
            {'Credit'}
          </strong>
        ),
      },
   

      {
        field: 'CLOSING_BALANCE',
        type: 'string',
        accessor: 'CLOSING_BALANCE',
        align: 'right',
        width:100,
        headerAlign: 'center',

        headerClassName: 'super-app-theme--header',
        cellClassName: 'super-app-theme--cell',
        renderHeader: (params) => (
          <strong className="text-[#555a66]" style={{ fontSize: 13 }}>
            {'Closing Bal.'}
          </strong>
        ),
      },
      {
        field: 'CLOSING_WITHOUT_OPENING',
        type: 'string',
        accessor: 'CLOSING_WITHOUT_OPENING',
        align: 'right',
        width:100,
        headerAlign: 'center',

        headerClassName: 'super-app-theme--header',
        cellClassName: 'super-app-theme--cell',
        renderHeader: (params) => (
          <div className="text-[#555a66]" style={{ fontSize: 13 }}>
            {'Closing Without Opening'}
          </div>
        ),
      },
      
    ],
    []
  );
  const columnsMobile = React.useMemo(
    () => [
      {
        field: 'DATE',
        accessor: 'DATE',
        // header:'Date',
        type: 'string',
        cellClassName: 'super-app-theme--cell',
        width: width * 18,
        headerAlign: 'center',
        renderCell: (params) => {
          if (params.value) {
            return <div>{params.value}</div>;
          } else {
            return <div>{''}</div>;
          }
        },
        align: 'left',
        headerClassName: 'super-app-theme--header',

        renderHeader: (params) => (
          <strong className="text-[#555a66]" style={{ fontSize: 13 }}>
            {'Date'}
          </strong>
        ),
      },


      {
        field: 'DEBIT',
        type: 'number',
        width: 60,

        headerAlign: 'center',
        align: 'right',
        headerClassName: 'super-app-theme--header',
        renderCell: (params) => {
          if (params.value) {
            return <div> {FormatNumber2(params.value)} </div>;
          } else {
            return '';
          }
        },
        renderHeader: (params) => <strong>{'Debit'}</strong>,
      },

      {
        field: 'CREDIT',
        type: 'number',
        width: 60,

        headerAlign: 'center',
        align: 'right',
        headerClassName: 'super-app-theme--header',
        renderCell: (params) => {
          if (params.value) {
            return (
              <div className="text-[#023606]">
                {' '}
                {FormatNumber2(params.value)}{' '}
              </div>
            );
          } else {
            return '';
          }
        },
        renderHeader: (params) => <strong>{'Credit'}</strong>,
      },

      {
        field: 'APPROVED',
        type: 'string',
        flex: 1,
        align: 'right',
        renderCell: (params) => {
          if (params.value) {
            return <div> {params.value} </div>;
          } else {
            return '';
          }
        },
        headerAlign: 'center',
        headerClassName: 'super-app-theme--header',
        renderHeader: (params) => <strong>{'Approved'}</strong>,
      },
    ],
    []
  );
  const token = useSelector(selectToken);
  const prefix = useSelector(selectPrefix);

  const station_id = useSelector(selectStationId);


  const getPartyledger = (opening=openingAllowed) => {
    setLoading(true);
    setPage(1);
    deleteWholeDatabase('Party_Wise_Balance_Report');
    CallAPIPromise(
      `/api/reports/partyWiseBalane`,
      {
        table_prefix: prefix,
        fdate: window.innerWidth <= 500 ? fromDate : firstDate,
        tdate: window.innerWidth <= 500 ? toDate : SecondDate,
        ACCOUNT_NO: accNumber,
        SID:ReduxStation_id
      },
      token,
      dispatch
    )
      .then((e) => {
        if (!e.data.error) {
          let list = [];
        const data = e.data.response;

        for (let i = 0; i < data.length; i++) {
          list.push({
            ...data[i],
            id: i + 1,
            OPENING_BALANCE: data[i].OPENING_BALANCE>0? FormatNumber2(data[i].OPENING_BALANCE)+ " "+data[i].OPENING_BAL_TYPE:"",
            CLOSING_BALANCE: data[i].CLOSING_BALANCE>0?FormatNumber2(data[i].CLOSING_BALANCE)+ " "+data[i].CLOSING_BAL_TYPE:"",
            CLOSING_WITHOUT_OPENING: data[i].CLOSING_WITHOUT_OPENING>0?FormatNumber2(data[i].CLOSING_WITHOUT_OPENING)+ " "+data[i].CLOSING_WITHOUT_OPENING_TYPE:"",
            OPENING_DEBIT:data[i].DEBIT>0?FormatNumber2(data[i].DEBIT):"",
            OPENING_CREDIT:data[i].CREDIT>0?FormatNumber2(data[i].CREDIT):"",
          });

        }

          setList(list);
        }
      })
      .catch((e) => {
        console.log(e);

        if (e.response?.data?.name === 'TokenExpiredError') {
          dispatch(setSessionExpired(true));
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const totalPages = Math.ceil(list.length / REPORT_PAGE_SIZE);
  const paginatedList = React.useMemo(() => {
    const startIndex = (page - 1) * REPORT_PAGE_SIZE;
    return list.slice(startIndex, startIndex + REPORT_PAGE_SIZE);
  }, [list, page]);

  useEffect(() => {
    if (totalPages && page > totalPages) {
      setPage(totalPages);
    }
  }, [page, totalPages]);

  useEffect(() => {
    const elseFunc = () => {
      if (userType === 'MANAGER') {
        dispatch(setStationID(''));
        dispatch(
          setCollectionAccountDetails({
            accName: '',
            accAddress: '',
            accMobile: '',
            accNumber: '',
            stationId: '',
          })
        );
        dispatch(setStationName(''));
      } else {
        dispatch(
          setCollectionAccountDetails({
            accName: '',
            accAddress: '',
            accMobile: '',
            accNumber: '',
            stationId: '',
          })
        );
      }
    };
    const callback = (details, data) => {
      setList(data);
      setPage(1);

      dispatch(
        setreportsFromDate(moment(details[0].from_date).format('YYYY-MM-DD'))
      );

      dispatch(
        setreportsTodate(moment(details[0].to_date).format('YYYY-MM-DD'))
      );

      dispatch(
        setCollectionAccountDetails({
          accName: details[0].accName,
          accAddress: details[0].accAddress,
          accMobile: details[0].accMobile,
          accNumber: details[0].ACCOUNT_NO,
          stationId: '',
        })
      );
    };
    IsLocalData('Party_Wise_Balance_Report', callback, elseFunc);

    dispatch(setReportType('Party_Wise_Balance_Report'));
  }, []);

  const okButton = () => {
    if (ReduxStation_id) {
    getPartyledger();
      
    } else {
      dispatch(setAlertWithTitle({
        title: 'Alert',
        msg:"Please select station first"
      }))
    }

  };

  return (
    <div className="h-screen w-full flex flex-col overflow-auto p-2">
      {window.innerWidth <= 500 ? (
        <>
          <div
            className="flex items-center py-3 px-1"
            style={{
              border: '1px solid #b5b3b3',
            }}
          >
            <div className="px-1 font-semibold">From </div>

            <GeniusSelectDate
              date={fromDate}
              setDate={setFromDate}
              dateFocus={fromDateFocus}
              SetDateFocus={setFromDateFocus}
            />
            <div className="px-1 font-semibold">To</div>
            <GeniusSelectDate
              date={toDate}
              setDate={setToDate}
              dateFocus={toDateFocus}
              SetDateFocus={setToDateFocus}
            />
          </div>
          <div
            style={{
              border: '1px solid #b5b3b3',
              borderTop: '0px',
            }}
            className="flex items-center pr-2"
          >
            <div>
              <button
                className="flex items-center rounded-sm ml-2"
                onClick={okButton}
                style={{
                  backgroundColor: '#c1c1c1',
                  paddingLeft: 30,
                  paddingRight: 30,
                  paddingTop: 4,
                  paddingBottom: 4,
                  color: 'black',
                }}
              >
                <div className="flex items-center text-sm">Ok</div>
              </button>
            </div>
          </div>
          <div
            style={{
              border: '1px solid #b5b3b3',
              borderTop: '0px',
            }}
            className="flex w-full"
          >
            <div
              style={
                userType === 'MANAGER'
                  ? {
                      fontSize: 12,
                      width: '100%',
                      color: '#a6a2a2',
                    }
                  : {
                      fontSize: 12,
                      width: '100%',
                      color: '#a6a2a2',
                    }
              }
              className=" flex whitespace-normal  py-3 justify-start items-center  "
            >
              {/* party name 1st part */}
              <div className="flex  h-full items-center px-2 ">
                <div
                  className="flex hover:cursor-pointer h-full items-center w-1/2"
                  onClick={() => dispatch(setModPartyMasterHelpStatus(true))}
                >
                  <div>
                    <i
                      className="bi bi-search"
                      style={{ color: '#f44336', fontSize: 15 }}
                    ></i>
                  </div>

                  <span
                    style={{ fontSize: 12 }}
                    className=" text-[#5c5b5b]  pl-2 flex font-semibold items-center"
                  >
                    Party
                    <span className="pl-1 text-[#5c5b5b] print:hidden font-semibold ">
                      Name
                    </span>
                  </span>
                </div>

                <div
                  style={{
                    border: '1px dotted #a6a2a2 ',
                    borderRadius: '3px',
                  }}
                  className="flex  w-20  pl-2 ml-2 "
                >
                  <input
                    size={'small'}
                    placeholder="All"
                    value={accNumber ? accNumber : 'select'}
                    style={{
                      width: '100%',
                      fontSize: 12,
                      paddingTop: '2px',
                      paddingBottom: '2px',
                      backgroundColor: 'transparent',
                    }}
                    readOnly
                    className=" outline-0 w-30 "
                  />
                </div>

                <div
                  style={{
                    border: '1px dotted #a6a2a2',
                    borderRadius: '3px',
                  }}
                  className="flex w-full h-full ml-2"
                >
                  <div className="flex grow h-full ">
                    <div className="w-full h-full">
                      <div
                        className="w-full h-1/2 print:h-full flex items-center"
                        style={{
                          fontSize: 12,
                          color: 'red',
                        }}
                      >
                        <span className="pl-4 font-semibold ">
                          {accDetails.accName}
                        </span>
                      </div>
                      <div
                        style={{
                          borderTop: '1px dotted #a6a2a2',
                          color: '#f2666f',
                          fontSize: 12,
                        }}
                        className="h-1/2 py-1 flex items-center print:hidden"
                      >
                        <span className="pl-4 font-semibold  ">
                          {accDetails.accAddress + ' '}
                          {accDetails.accMobile}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
          <div style={{
            width:columns.reduce((acc, curr) => acc + curr.width, 0)+40
          }}>
               <FromToDate
            submit={okButton}
            
          otherButton={
            list[0] && (
              <div className='flex '>
                <ReactToPrint
                  trigger={() => {
                    return (
                      <button
                        type="button"
                        title="Print party wise balance report"
                        className="ml-2 inline-flex h-9 items-center gap-2 rounded-md bg-slate-800 px-4 text-sm font-semibold text-white shadow-sm transition hover:bg-slate-700"
                      >
                        <Printer size={16} />
                        <span>Print Report</span>
                      </button>
                    );
                  }}
                  content={() => printRef.current}
                />


              </div>
            )
          }
            
          reset={() => {
            if (userType === 'MANAGER') {
              dispatch(setStationID(''));
              dispatch(setStationName(''));
              dispatch(
                setCollectionAccountDetails({
                  accName: '',
                  accAddress: '',
                  accMobile: '',
                  accNumber: '',
                  stationId: '',
                })
              );
            } else {
              dispatch(
                setCollectionAccountDetails({
                  accName: '',
                  accAddress: '',
                  accMobile: '',
                  accNumber: '',
                  stationId: '',
                })
              );
            }
          }}
          
        />
          </div>
     
      )}

      <div
        className="mt-2 flex w-full max-w-full items-center justify-between gap-3"
      >


        <div className="flex overflow-hidden rounded-md border border-slate-300 bg-white print:hidden">
          <button
            type="button"
            onClick={() => setActiveView('report')}
            className={`inline-flex items-center gap-2 px-4 py-1.5 text-sm font-semibold ${
              activeView === 'report'
                ? 'bg-slate-800 text-white'
                : 'text-slate-700 hover:bg-slate-100'
            }`}
          >
            <Table2 size={15} />
            Report
          </button>
          <button
            type="button"
            onClick={() => setActiveView('graph')}
            className={`inline-flex items-center gap-2 border-l border-slate-300 px-4 py-1.5 text-sm font-semibold ${
              activeView === 'graph'
                ? 'bg-slate-800 text-white'
                : 'text-slate-700 hover:bg-slate-100'
            }`}
          >
            <BarChart3 size={15} />
            Graph
          </button>
        </div>
      </div>

      {activeView === 'graph' ? (
        <div className="w-full max-w-full">
          <PartyBalanceGraph rows={list} openingAllowed={openingAllowed} />
        </div>
      ) : (
        <div
          className="flex w-full max-w-full flex-col items-start gap-3 pt-2 xl:flex-row"
        >
          <div className="flex min-w-0 flex-1 flex-col">
            <PartyBalanceTable
              rows={paginatedList}
              allRows={list}
              loading={loading}
            />
            <div className="flex flex-wrap items-center justify-between gap-2 border-x border-b border-slate-300 bg-white px-3">
              <div className="py-3 text-xs font-medium text-slate-500">
                {list.length
                  ? `Showing ${(page - 1) * REPORT_PAGE_SIZE + 1}-${Math.min(
                      page * REPORT_PAGE_SIZE,
                      list.length
                    )} of ${list.length}`
                  : '0 records'}
              </div>
            <GeniusPaginationButtons
              page={page}
              totalPages={totalPages}
              onPageChange={setPage}
            />
            </div>
          </div>
          <TopPartiesPanel rows={list} openingAllowed={openingAllowed} />
        </div>
      )}
     
      <ModListStationMaster
        onRowClick={(p) => {
          dispatch(setStationID(p.row.CODE));
          dispatch(setStationName(p.row.STATION_NAME));
          dispatch(setListStationMasterModalStatus(false));
        }}
      />
      <ModPartyMasterHelp
        SID={station_id}
        onRowClick={(params) => {
          const name = params.row.NAME;
          const mobile = params.row.MOBILE;
          const accNumber = params.row.ACCOUNT_NO;
          const address = params.row.ADDRESS;
          const stationId = params.row.SID;
          const stationName = params.row.SNAME;
          dispatch(
            setCollectionAccountDetails({
              accName: name,
              accAddress: address,
              accMobile: mobile,
              accNumber: accNumber,
              stationId: stationId,
              sName: stationName,
            })
          );
          dispatch(setModPartyMasterHelpStatus(false));
        }}
        onClose={() => {
          dispatch(setModPartyMasterHelpStatus(false));
        }}
      />
      {  <div
        id="party-balance-print-source"
        ref={printRef}
        className="w-full"
      >
        <GeniusTableForReports
          stationId={`${ReduxStation_id} - ${ReduxStationName}`}
          date={fromDate}
          date1={toDate}
          columns={columns}
          data={list}
          footerInsideTable
          Fotter={   <PartyLedgerFooter
            rows={list}
            columns={window.innerWidth <= 500 ? columnsMobile : columns}
            insideTable
          />}
          title={'Party Wise Balance'}
        />
      </div>}
      
    </div>
  );
};

export default PartyWiseBalanceReport;
